import { openBlock as e, createElementBlock as o, createElementVNode as c } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, n = /* @__PURE__ */ c("path", {
  fill: "currentColor",
  d: "M21.74 11.239a.99.99 0 0 0-.99-.89H13.2c-.55 0-1 .45-1 1v1.71c0 .55.45 1 1 1h4.51c-.11.92-.71 2.31-2.04 3.24-.85.59-1.98 1-3.47 1-.07 0-.13 0-.2-.01-2.55-.08-4.71-1.79-5.49-4.14a6.2 6.2 0 0 1-.33-1.98c0-.69.12-1.36.32-1.98q.09-.27.21-.54c.92-2.07 2.93-3.53 5.29-3.6.06-.01.13-.01.2-.01 1.43 0 2.5.47 3.25.99.39.27.91.21 1.25-.12l1.39-1.36c.44-.43.4-1.16-.1-1.52-1.59-1.17-3.53-1.86-5.79-1.86-.07 0-.13 0-.2.01a9.96 9.96 0 0 0-8.73 5.5c-.68 1.36-1.07 2.88-1.07 4.49s.39 3.13 1.07 4.49h.01a9.96 9.96 0 0 0 8.72 5.5c.07.01.13.01.2.01 2.7 0 4.97-.89 6.62-2.42 1.89-1.75 2.98-4.31 2.98-7.36 0-.43-.02-.8-.06-1.15"
}, null, -1), l = [
  n
];
function r(s, a) {
  return e(), o("svg", t, [...l]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
